import { get } from 'lodash-es';

import type { RateBrowserState } from './rate-browser.types';
import type { RootState } from 'store/root-state';

export const getConfigureRatesModel = (state: RateBrowserState) => get(state, 'configureRatesModel');
export const getShowCreateLabelContent = (state: RateBrowserState): boolean => get(state, 'showCreateLabelContent', false);
export const getModalId = (state: RateBrowserState): string | undefined => get(state, 'modalId');

export const selectRateBrowsergetConfigureRatesModel = (state: RootState) => getConfigureRatesModel(get(state, 'rateBrowser'));
export const selectRateBrowsergetShowCreateLabelContent = (state: RootState): boolean =>
  getShowCreateLabelContent(get(state, 'rateBrowser'));
export const selectRateBrowsergetModalId = (state: RootState): string | undefined => getModalId(get(state, 'rateBrowser'));
